import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CoffeeCard from './CoffeeCard';
import { coffeeData, Coffee } from './coffeeData';
import EditCoffeeModal from './EditCoffeeModal';
interface CoffeeListProps {
  activeFilter: 'all' | 'upcoming' | 'mine' | 'past';
  searchQuery: string;
  selectedTopic: string;
}
const CoffeeList: React.FC<CoffeeListProps> = ({
  activeFilter,
  searchQuery,
  selectedTopic
}) => {
  const navigate = useNavigate();
  const now = new Date();
  const [coffeeToEdit, setCoffeeToEdit] = useState<Coffee | null>(null);
  const [localCoffeeData, setLocalCoffeeData] = useState([...coffeeData]);
  // Filter coffee meetings based on active filter, search query, and selected topic
  const filteredCoffee = localCoffeeData.filter(coffee => {
    const coffeeDate = new Date(coffee.date);
    const isFuture = coffeeDate > now;
    const isPast = coffeeDate < now;
    const isUserParticipant = coffee.participants.some(p => p.id === 'current-user');
    const isUserHost = coffee.host.id === 'current-user';
    // Apply tab filters
    switch (activeFilter) {
      case 'upcoming':
        // Show only future events, regardless of who created them
        if (!isFuture) return false;
        break;
      case 'mine':
        // Show events where the current user is a participant OR the host
        if (!isUserParticipant && !isUserHost) return false;
        break;
      case 'past':
        // Show only past events
        if (!isPast) return false;
        break;
      case 'all':
      default:
        // No additional filtering for "all" tab
        break;
    }
    // Apply topic filter if a specific topic is selected
    if (selectedTopic !== 'all') {
      const normalizedSelectedTopic = selectedTopic.toLowerCase();
      const hasMatchingTopic = coffee.topics.some(topic => topic.toLowerCase().includes(normalizedSelectedTopic));
      if (!hasMatchingTopic) return false;
    }
    // Apply search query filter
    if (searchQuery.trim()) {
      const normalizedQuery = searchQuery.toLowerCase().trim();
      return coffee.title.toLowerCase().includes(normalizedQuery) || coffee.host.name.toLowerCase().includes(normalizedQuery) || coffee.description.toLowerCase().includes(normalizedQuery) || coffee.topics.some(topic => topic.toLowerCase().includes(normalizedQuery));
    }
    // If all filters pass, include the coffee event
    return true;
  });
  // Sort by date - from most recent to furthest (descending order)
  const sortedCoffee = [...filteredCoffee].sort((a, b) => {
    // Reverse the order to get descending (newest first)
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });
  // Navigate to coffee detail page
  const handleCoffeeClick = (coffeeId: string) => {
    navigate(`/coffee/${coffeeId}`);
  };
  const handleEditCoffee = (coffee: Coffee) => {
    setCoffeeToEdit(coffee);
  };
  const handleUpdateCoffee = (updatedCoffee: Partial<Coffee>) => {
    if (coffeeToEdit) {
      // In a real app, this would make an API call
      // For now, we'll just update the local state
      const updatedData = localCoffeeData.map(c => c.id === coffeeToEdit.id ? {
        ...c,
        ...updatedCoffee
      } : c);
      setLocalCoffeeData(updatedData);
      setCoffeeToEdit(null);
      // Show a success message
      alert('Evento aggiornato con successo!');
    }
  };
  const handleDeleteCoffee = (coffee: Coffee) => {
    // In a real app, this would make an API call
    // For now, we'll just update the local state
    const updatedData = localCoffeeData.filter(c => c.id !== coffee.id);
    setLocalCoffeeData(updatedData);
    // Show a success message
    alert('Evento eliminato con successo!');
  };
  return <div className="space-y-8" data-id="element-173">
      {sortedCoffee.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-174">
          {sortedCoffee.map(coffee => <CoffeeCard key={coffee.id} coffee={coffee} onClick={() => handleCoffeeClick(coffee.id)} onEdit={handleEditCoffee} onDelete={handleDeleteCoffee} data-id="element-175" />)}
        </div> : <div className="bg-white rounded-xl border border-gray-200 p-8 text-center" data-id="element-176">
          <p className="text-gray-600" data-id="element-177">
            Nessun evento trovato con i filtri selezionati.
          </p>
        </div>}

      {/* Edit Coffee Modal */}
      {coffeeToEdit && <EditCoffeeModal isOpen={!!coffeeToEdit} onClose={() => setCoffeeToEdit(null)} coffee={coffeeToEdit} onUpdate={handleUpdateCoffee} onDelete={() => {
      handleDeleteCoffee(coffeeToEdit);
      setCoffeeToEdit(null);
    }} data-id="element-178" />}
    </div>;
};
export default CoffeeList;